import React from "react";
import leftImg from "../Images/left.png";
import rightImg from "../Images/right.png";

export default function GoodFirmsBadge() {
  return (
    <div className="flex justify-center">
      <div className="w-[220px] h-[220px] rounded-full border-2 border-blue-500 flex flex-col items-center justify-center bg-white">

        <h3 className="text-2xl font-bold text-blue-500">
          GoodFirms
        </h3>

        <div className="flex gap-1 my-2">
          <span className="text-amber-500 text-lg">★</span>
          <span className="text-amber-500 text-lg">★</span>
          <span className="text-amber-500 text-lg">★</span>
          <span className="text-amber-500 text-lg">★</span>
          <span className="text-amber-500 text-lg">★</span>
        </div>

        <div className="flex items-center justify-center gap-0 px-1">
          <img src={leftImg} alt="left" className="w-14 h-14 object-contain" />
          <h4 className="text-center font-bold text-xs text-gray-800 leading-tight whitespace-nowrap">
            Top Mobile App<br />Development Company
          </h4>
          <img src={rightImg} alt="right" className="w-14 h-14 object-contain" />
        </div>

      </div>
    </div>
  );
}
